var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFireFeaturesSpotFireConfirmed = function SvgFireFeaturesSpotFireConfirmed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.711,
    r: 9,
    stroke: "#DF0000",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DF0000",
    fillRule: "evenodd",
    d: "M7.293 17.404a1 1 0 0 1 0-1.414l7.914-7.915a1 1 0 1 1 1.415 1.415l-7.915 7.914a1 1 0 0 1-1.414 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DF0000",
    fillRule: "evenodd",
    d: "M7.553 8.004a1 1 0 0 1 1.414 0l7.914 7.915a1 1 0 1 1-1.414 1.414L7.553 9.42a1 1 0 0 1 0-1.415",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DF0000",
    fillRule: "evenodd",
    d: "M5.374 12.638a1 1 0 0 1 1-1h11.193a1 1 0 0 1 0 2H6.374a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#DF0000",
    fillRule: "evenodd",
    d: "M12.204 6.175a1 1 0 0 1 1 1v11.192a1 1 0 1 1-2 0V7.176a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};
export default SvgFireFeaturesSpotFireConfirmed;